interface Props {
  className?: string;
}

export default function RulerIcon({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 23">
      <path
        fill="currentColor"
        d="M24 23V0L0 23h3v-2h1v2h2v-3h1v3h2v-2h1v2h2v-3h1v3h2v-2h1v2h2v-3h1v3h2v-2h1v2h2Zm-4-4H9.5L20 9v10Z"
      />
    </svg>
  );
}
